<script setup lang="ts"></script>

<template>
  <div class="bg-frame">
    <slot />
  </div>
</template>

<style scoped>
.bg-frame {
  background-image: url("~/assets/images/frame.svg");
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100% auto;
}
</style>
